import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Silenziosa: browser console log
    console.error("[ErrorBoundary]", error, info);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const msg = String(this.state.error?.message || this.state.error || "Errore");
      const isCamera = /Unavailable|camera|permission|getUserMedia/i.test(msg);
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#050608] p-4">
          <div className="gm-card max-w-lg w-full p-6" data-testid="error-boundary">
            <div className="flex items-start gap-3 mb-4">
              <div className="h-12 w-12 bg-[#FF9F0A]/10 border border-[#FF9F0A]/30 flex items-center justify-center shrink-0">
                <AlertTriangle className="text-[#FF9F0A]" size={22} />
              </div>
              <div>
                <div className="font-display text-2xl font-black uppercase tracking-tight">Si è verificato un errore</div>
                <div className="text-sm text-zinc-400 mt-1">
                  {isCamera
                    ? "Non è stato possibile accedere alla fotocamera. Verifica i permessi del browser oppure usa l'inserimento manuale."
                    : "L'applicazione ha incontrato un problema. I tuoi dati sono al sicuro nel database."}
                </div>
              </div>
            </div>
            <div className="bg-zinc-900/50 border border-zinc-800 p-3 rounded-sm text-xs font-mono-data text-zinc-400 mb-4 max-h-32 overflow-auto">
              {msg}
            </div>
            <div className="flex gap-2">
              <button onClick={() => window.location.href = "/"} className="gm-btn-primary h-11 px-5 rounded-sm flex items-center gap-2" data-testid="error-boundary-home">
                <RefreshCw size={16} /> Torna alla dashboard
              </button>
              <button onClick={this.reset} className="h-11 px-5 border border-zinc-700 text-zinc-300 uppercase text-xs tracking-widest font-bold hover:border-white">
                Riprova
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
